import { Table } from 'antd';
import "./../../assets/css/global.css";

const TablaFiscal = ({ relationships, loading }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fechaRel',
            key: 'fechaRel',
            render: (fechaRel) => {
                let date = fechaRel.split("T")[0].split("-").reverse().join("/");
                return date;
            }
            // render: (fechaRel) => `${new Date(fechaRel).toLocaleDateString("es-MX", {
            //     year: "numeric",
            //     month: "2-digit",
            //     day: "2-digit",
            // })}`
        },
        {
            title: 'Relación',
            dataIndex: 'relacion',
            key: 'relacion',
        },
        {
            title: 'Abono',
            dataIndex: 'abono',
            key: 'abono',
            render: (abono) => `$ ${numberFormat.format(abono || 0)}`
        },
        {
            title: 'Retiro',
            dataIndex: 'retiro',
            key: 'retiro',
            render: (retiro) => `$ ${numberFormat.format(retiro || 0)}`
        },
        {
            title: 'Saldo',
            dataIndex: 'saldo',
            key: 'saldo',
            render: (saldo) => `$ ${numberFormat.format(saldo || 0)}`
        }
    ];

    return (
        <>
            <Table 
                columns={columns} 
                dataSource={relationships} 
                rowKey={record => record.relacion}
                loading={loading} 
                onRow={(record) => {
                    let backgroundColor = "";
                    if (record.tipo === "ABONO_CREDITO") backgroundColor = "#f6ffed";   // verde tenue
                    return {
                        style: {
                            backgroundColor
                        }
                    };
                }}
                pagination={false}
            />
        </>
    )
}

export default TablaFiscal;